import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useLocation,
} from 'react-router-dom';
import Login from './components/Login';
import Overview from './components/Overview';
import Users from './components/Users';
import Transactions from './components/Transactions';
import Mt5Transactions from './components/Mt5Transactions';     
import BankTransactions from './components/BankTransactions';     
import Settings from './components/Settings';
import Navbar from './components/Navbar';
import Notifications from './components/Notifications';
import './index.css';

// ProtectedRoute – checks token & renders layout (sidebar + page)
const ProtectedRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();

  //useEffect(() => {
  //  const handleContextMenu = (e) => e.preventDefault();
  //  document.addEventListener("contextmenu", handleContextMenu);

  //  return () => {
  //    document.removeEventListener("contextmenu", handleContextMenu);
  //  };
  //}, []);


  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

// Layout – Navbar + mobile overlay + mobile header
const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen((v) => !v);

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <Navbar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        handleLogout={handleLogout}
      />

      {/* Mobile overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* Main content area */}
      <div className="flex-1 bg-gray-100">
        {/* Mobile top bar */}
        <div className="md:hidden p-2 bg-farmer-dark text-white flex justify-between items-center sticky top-0 z-30">
          <button onClick={toggleSidebar} className="focus:outline-none">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              />
            </svg>
          </button>
          <h2 className="text-sm font-sftsMedium">Instant Transfer</h2>
        </div>

        {/* Page content */}
        {children}
      </div>
    </div>
  );
};

// 404 Page
const NotFound = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-100">
    <div className="text-center">
      <h1 className="text-6xl font-bold text-farmer-dark">404</h1>
      <p className="text-lg text-gray-600 mt-2">Page Not Found</p>
      <a
        href="/overview"
        className="mt-4 inline-block px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
      >
        Go to Dashboard
      </a>
    </div>
  </div>
);

// Main App
const App = () => {
  return (
    <Router>
      <Switch>
        {/* Public */}
        <Route exact path="/login" component={Login} />

        {/* Protected Routes */}
        <ProtectedRoute exact path="/" component={Overview} />
        <ProtectedRoute path="/overview" component={Overview} />
        <ProtectedRoute path="/users" component={Users} />
        <ProtectedRoute path="/transactions" component={Transactions} />

        {/* NEW PAGES */}
        <ProtectedRoute path="/mt5-transactions" component={Mt5Transactions} />
        <ProtectedRoute path="/bank-transactions" component={BankTransactions} />

        <ProtectedRoute path="/notifications" component={Notifications} />
        <ProtectedRoute path="/settings" component={Settings} />

        {/* 404 - must be last */}
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

export default App;